'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_FETCH_ALL_LIMIT = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _UrlConstructionError = require('./errors/UrlConstructionError');

var _UrlConstructionError2 = _interopRequireDefault(_UrlConstructionError);

var _MalformedGraphQLQueryError = require('./errors/MalformedGraphQLQueryError');

var _MalformedGraphQLQueryError2 = _interopRequireDefault(_MalformedGraphQLQueryError);

var _UnauthorizedError = require('./errors/UnauthorizedError');

var _UnauthorizedError2 = _interopRequireDefault(_UnauthorizedError);

var _MissingParamError = require('./errors/MissingParamError');

var _MissingParamError2 = _interopRequireDefault(_MissingParamError);

var _InvalidParamError = require('./errors/InvalidParamError');

var _InvalidParamError2 = _interopRequireDefault(_InvalidParamError);

var _RequestMaker = require('./RequestMaker');

var _RequestMaker2 = _interopRequireDefault(_RequestMaker);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var DEFAULT_FETCH_ALL_LIMIT = exports.DEFAULT_FETCH_ALL_LIMIT = 100;
/**
 * Client
 * @param {any} fetch an object implementing the fetch api (for browsers this can be fetch.bind() for node require('node-fetch'))
 * @param {Object} options options object input data and dependency injection
 * @param {Object} options.fetch change fetch method from whatwg-fetch (optional, default: whatwg-fetch)
 * @param {string} options.protocol the http protocol of the service endpoint
 * @param {string} options.host the host of the service endpoint
 * @param {string} options.path the path of the service endpoint (optional)
 * @param {number} options.retries the number of times the client should retry on network error / service error (optional, default: 3)
 * @param {number} options.delayInSecs the delay between retries (optional, default: 2)
 * @param {Object} options.credentials identifiers and secrets required to hit protected endpoints (optional)
 * @param {string} options.region states the region of the service for signing (optional, default: eu-west-1)
 * @param {RequestMaker} options.requestMaker for overriding request making logic (optional, default: RequestMaker)
 * @param {string} options.correlationId specifies the correlation id to use in the request (optional)
 * @param {boolean} options.traceLogging sets trace logging on/off (optional, default: false)
 * @param {Function} options.getUserRegion optional function to return a user's region
 * @param {Function} options.getUserLanguage optional function to return a user's language
 * @throws {UrlConstructionError} when either options.protocol or options.host is missing
 */

var Client = function () {
  function Client(fetch) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    (0, _classCallCheck3.default)(this, Client);

    if (!fetch || typeof fetch !== 'function') {
      throw new _MissingParamError2.default('fetch');
    }

    this.fetch = fetch;
    this.options = options;

    if (!this.options.protocol || !this.options.host) {
      throw new _UrlConstructionError2.default(this.options.protocol, this.options.host, this.options.path);
    }

    this.url = this.options.protocol + '://' + this.options.host;

    if (this.options.path) {
      this.url += this.options.path;
    }

    this.retries = this.options.retries;
    this.delayInSecs = this.options.delayInSecs;
    this.credentials = this.options.credentials;
    var requestMakerOpts = {
      retries: this.retries,
      delayInSecs: this.delayInSecs,
      credentials: this.credentials,
      region: this.options.region || 'eu-west-1',
      correlationId: this.options.correlationId,
      traceLogging: this.options.traceLogging || false,
      signal: this.options.signal || undefined,
      getUserRegion: this.options.getUserRegion,
      getUserLanguage: this.options.getUserLanguage
    };
    this.requestMaker = this.options.requestMaker || new _RequestMaker2.default(this.fetch, requestMakerOpts);
  }

  (0, _createClass3.default)(Client, [{
    key: 'graphQL',

    /**
     * Performs and returns a GraphQL query. This method will always lookup the
     * POST /api/graphql on the endpoint
     * @param {string} query
     * @param {Object<string, string|number|Array<string>|Array<number>>} variables
     * @throws {MalformedGraphQLQueryError} thrown when query syntax is malformed
     * @throws {UnauthorizedError} when unauthorized to query the graphql endpoint
     */
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)(
      /*#__PURE__*/
      _regenerator2.default.mark(function _callee(query, variables) {
        var body, response, errors, graphQLError, error, reason;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                body = {
                  query: query,
                  variables: variables,
                  operationName: ''
                };
                _context.next = 3;
                return this.requestMaker.makeRequest(this.url + '/api/graphql', {
                  method: 'POST',
                  body: (0, _stringify2.default)(body)
                }, [200, 400]);

              case 3:
                response = _context.sent;

                if (!(response.status === 400)) {
                  _context.next = 8;
                  break;
                }

                errors = response.json.errors || [];
                graphQLError = errors[0] || {};
                throw new _MalformedGraphQLQueryError2.default((0, _stringify2.default)(graphQLError));

              case 8:
                if (!response.json.errors) {
                  _context.next = 14;
                  break;
                }

                error = response.json.errors[0];

                if (!(error.extensions && error.extensions.exception && error.extensions.exception.name === 'UnauthorizedError')) {
                  _context.next = 14;
                  break;
                }

                reason = 'No credentials are present';

                if (this.credentials && this.credentials.accessToken) {
                  reason = 'Credentials are invalid';
                }

                throw new _UnauthorizedError2.default(reason);

              case 14:
                return _context.abrupt('return', response.json);

              case 15:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function graphQL(_x2, _x3) {
        return _ref.apply(this, arguments);
      }

      return graphQL;
    }()
  }, {
    key: '_pageMethod',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)(
      /*#__PURE__*/
      _regenerator2.default.mark(function _callee2() {
        var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            method = _ref3.method,
            _ref3$pageToItems = _ref3.pageToItems,
            pageToItems = _ref3$pageToItems === undefined ? function (page) {
          return page.items;
        } : _ref3$pageToItems,
            options = _ref3.options;

        var items, lastKey, page;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(typeof method !== 'function')) {
                  _context2.next = 2;
                  break;
                }

                throw new _InvalidParamError2.default('method', '', 'recieved ' + (typeof method === 'undefined' ? 'undefined' : (0, _typeof3.default)(method)) + ' must be a function');

              case 2:
                items = [];
                lastKey = undefined;

              case 4:
                _context2.next = 6;
                return method((0, _extends3.default)({}, options, {
                  lastKey: lastKey
                }));

              case 6:
                page = _context2.sent;
                lastKey = page.lastKey;
                items = items.concat(pageToItems(page));

              case 9:
                if (lastKey) {
                  _context2.next = 4;
                  break;
                }

              case 10:
                return _context2.abrupt('return', items);

              case 11:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function _pageMethod() {
        return _ref2.apply(this, arguments);
      }

      return _pageMethod;
    }()
  }, {
    key: '_generatePagingQueryParams',
    value: function _generatePagingQueryParams() {
      var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref4$limit = _ref4.limit,
          limit = _ref4$limit === undefined ? DEFAULT_FETCH_ALL_LIMIT : _ref4$limit,
          lastKey = _ref4.lastKey;

      var params = [];
      limit && params.push('limit=' + limit);
      lastKey && params.push('lastKey=' + encodeURIComponent(lastKey));
      return params;
    }
  }, {
    key: '_validateMissingParams',
    value: function _validateMissingParams(args) {
      (0, _keys2.default)(args).forEach(function (argName) {
        if (!args[argName]) {
          throw new _MissingParamError2.default(argName);
        }
      });
    }
  }, {
    key: 'version',
    value: function () {
      var _ref5 = (0, _asyncToGenerator3.default)(
      /*#__PURE__*/
      _regenerator2.default.mark(function _callee3() {
        var response;
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.requestMaker.makeRequest(this.url + '/api/version', {
                  method: 'GET'
                }, [200]);

              case 2:
                response = _context3.sent;
                return _context3.abrupt('return', response.json);

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function version() {
        return _ref5.apply(this, arguments);
      }

      return version;
    }()
  }, {
    key: 'credentials',
    get: function get() {
      return this.credentials_;
    },
    set: function set(value) {
      this.credentials_ = value;

      if (this.requestMaker) {
        this.requestMaker.credentials = value;
      }
    }
  }]);
  return Client;
}();

exports.default = Client;